import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Form, Spinner } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import ServiceForm from './ServiceForm'

import { storeService } from '../services'
import { handleError } from '../../../helpers'

export default function NewServiceModal({ visible, onClose, reload }) {
	const { handleSubmit, register, formState: { errors }, setValue, watch } = useForm()
	const [loading, setLoading] = useState(false)

	const onSubmit = values => {
		setLoading(true)
		values.service_at = `${values.service_at_day} ${values.service_at_time}:00`
		storeService(values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Programa Nuevo Servicio</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<ServiceForm 
							register={register}
							errors={errors}
							setValue={setValue}
							watch={watch}
						/>
						<Button color='primary' type="submit" disabled={loading}>
							{ loading && <Spinner animation='border' size="sm" className='mr-1' /> }
							Agregar Servicio
						</Button>
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}